export default {"src":"/_next/static/media/rhoc.64fd7c83.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};